export interface EvidenceEntry {
  key: string;
  value: string;
}

function asText(value: unknown): string {
  if (value === null || value === undefined || value === '') return '–';
  if (typeof value === 'string') return value;
  if (typeof value === 'number' || typeof value === 'boolean') return String(value);
  return JSON.stringify(value);
}

// Each class carries its own evidence, so every entry is shown as it came: arrays and nested
// objects as the text they serialise to.
export function evidenceEntries(evidence: Record<string, unknown> | null): EvidenceEntry[] {
  return Object.entries(evidence ?? {}).map(([key, value]) => ({ key, value: asText(value) }));
}
